import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export default function ScrollToTop() {
    const {key, pathname} = useLocation();

    const blacklist = ['portfolio', 'investment', 'page', '?ca'];
    const res = blacklist.map((item) => {
        return pathname.includes(item);
    });

    useEffect(() => {
        if (!res.includes(true)) {
            window.scrollTo({behavior: 'smooth', top: 0, left: 0});
        }
    }, [key, res]);

    return null;
}
